import { fixWebmDuration } from '@fix-webm-duration/fix'

function recordingFormat() {
  if (typeof MediaRecorder === 'undefined') throw new Error('MediaRecorder is not supported')
  const formats = [
    { mimeType: 'video/webm;codecs=vp8', extension: 'webm' },
    { mimeType: 'video/webm', extension: 'webm' },
    { mimeType: 'video/mp4', extension: 'mp4' },
  ]
  const format = formats.find(({ mimeType }) => MediaRecorder.isTypeSupported(mimeType))
  if (!format) throw new Error('No supported camera recording format')
  return format
}

export default function createSurveyFaceRecording() {
  const feed = document.getElementById('webgazerVideoFeed')
  const sourceStream = feed?.srcObject
  const tracks = sourceStream?.getVideoTracks?.() || []
  if (!tracks.length) throw new Error('Eye-tracking camera stream is unavailable')

  const format = recordingFormat()
  const recorder = new MediaRecorder(new MediaStream(tracks), {
    mimeType: format.mimeType,
    videoBitsPerSecond: 650000,
  })
  const chunks = []
  let startedAt = 0
  recorder.addEventListener('dataavailable', (event) => {
    if (event.data?.size) chunks.push(event.data)
  })

  return {
    start() {
      if (recorder.state !== 'inactive' || startedAt) return
      recorder.start(500)
      startedAt = performance.now()
    },
    async stop() {
      if (!startedAt || recorder.state === 'inactive') throw new Error('Camera recording did not start')
      const durationMs = Math.max(1, Math.round(performance.now() - startedAt))
      const stopped = new Promise((resolve, reject) => {
        recorder.addEventListener('stop', resolve, { once: true })
        recorder.addEventListener('error', (event) => reject(event.error || new Error('Camera recording failed')), { once: true })
      })
      recorder.stop()
      await stopped
      const contentType = recorder.mimeType || format.mimeType
      const rawBlob = new Blob(chunks, { type: contentType })
      if (!rawBlob.size) throw new Error('Camera recording is empty')
      const blob = format.extension === 'webm'
        ? await fixWebmDuration(rawBlob, durationMs, { logger: false })
        : rawBlob
      return { blob, durationMs, extension: format.extension }
    },
    abort() {
      if (recorder.state !== 'inactive') recorder.stop()
    },
  }
}
